import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  TextField,
  Divider,
  useTheme,
} from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { Link, useParams } from 'react-router-dom';
import CommentIcon from '@mui/icons-material/Comment';
import PersonIcon from '@mui/icons-material/Person';
import { useDispatch, useSelector } from 'react-redux';
import {
  Get_Selected_Commission_Schedual_Data_Action,
  Update_Selected_Commission_Schedual_Data_Action,
} from '../Redux/Actions/Commission_Schedual_Dates_Actions';
import { Notify } from '../Utility/Notify';

export const UpdateSchedualDateForCommissionPage = () => {
  const theme = useTheme();
  const mode = theme.palette.mode; // جلب الوضع ال

  const { id } = useParams();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    Date: '',
    MoneyPayment: '',
    Comment: '',
  });

  const [loading, setLoading] = useState(true);

  const resselecteddataSchdualdate = useSelector(
    (state) => state.AllSchedual_Commission_Dates.Get_Selected_Payment_Date,
  );
  const selectedData = resselecteddataSchdualdate?.data || null;

  useEffect(() => {
    dispatch(Get_Selected_Commission_Schedual_Data_Action(id));
  }, [dispatch, id]);

  // Fill state when data loads
  useEffect(() => {
    if (selectedData) {
      setFormData({
        Date: selectedData?.Date ? new Date(selectedData.Date).toISOString().split('T')[0] : '',
        MoneyPayment: selectedData?.MoneyPayment || '',
        Comment: selectedData?.Comment || '',
      });
    }
  }, [selectedData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const SubmitUpdate = async () => {
    setLoading(true);
    await dispatch(Update_Selected_Commission_Schedual_Data_Action(id, formData));
    setLoading(false);
  };

  const resselecteddataSchdualdateupdate = useSelector(
    (state) => state.AllSchedual_Commission_Dates.Update_Selected_Payment_Date,
  );

  useEffect(() => {
    if (loading === false) {
      if (resselecteddataSchdualdateupdate?.status === 200) {
        Notify('success', 'Data Updated Successfully', 'success');
      } else {
        Notify('error', 'Data Updated Successfully', 'error');
        return;
      }
    }
  }, [loading]);

  return (
    <Container className="startpage py-4">
      <div className="mb-3">
        <Link
          to="/LeadsForAccountant"
          style={{ textDecoration: 'none', color: '#0F7687', fontWeight: 'bold' }}
        >
          Home
        </Link>
        <KeyboardDoubleArrowRightIcon />
        <span style={{ fontWeight: 'bold', color: '#333' }}>
          Update Commission Payment Schedule
        </span>
      </div>

      <hr />

      <Card
        sx={{
          maxWidth: 600,
          margin: '0 auto',
          p: 2,
          borderRadius: 3,
          boxShadow: 4,
          backgroundColor: '#fdfdfd',
        }}
        style={{
          color: mode === 'dark' ? '#90caf9' : '#0F7687',
          backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
        }}
      >
        <CardContent>
          <Typography variant="h5" sx={{ mb: 3, color: '#0F7687', fontWeight: 'bold' }}>
            Update Commission Payment
          </Typography>

          {/* Lead Name */}
          <Box mb={3} display="flex" alignItems="center" gap={1}>
            <PersonIcon sx={{ color: '#0F7687' }} />
            <Typography variant="subtitle1">
              <strong>Lead:</strong> {selectedData?.lead?.name || 'Unnamed Lead'}
            </Typography>
          </Box>

          <Divider sx={{ mb: 3 }} />

          {/* Payment Date */}
          <Box mb={3} display="flex" alignItems="center" gap={2}>
            <CalendarMonthIcon sx={{ color: '#0F7687' }} />
            <TextField
              fullWidth
              type="date"
              name="Date"
              label="Payment Date"
              InputLabelProps={{ shrink: true }}
              value={formData.Date}
              onChange={handleChange}
            />
          </Box>

          {/* Payment Amount */}
          <Box mb={3} display="flex" alignItems="center" gap={2}>
            <MonetizationOnIcon sx={{ color: '#0F7687' }} />
            <TextField
              fullWidth
              type="number"
              name="MoneyPayment"
              label="Payment Amount"
              placeholder="Enter amount in AED"
              InputLabelProps={{ shrink: true }}
              value={formData.MoneyPayment}
              onChange={handleChange}
            />
          </Box>

          {/* Comment */}
          <Box mb={3} display="flex" alignItems="center" gap={2}>
            <CommentIcon sx={{ color: '#0F7687' }} />
            <TextField
              fullWidth
              multiline
              name="Comment"
              label="Comment"
              placeholder="Write any notes or comments"
              rows={3}
              value={formData.Comment}
              onChange={handleChange}
            />
          </Box>

          {/* Confirm Button */}
          <Box display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              color="success"
              startIcon={<CheckCircleIcon />}
              onClick={SubmitUpdate}
            >
              Confirm Update
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};
